import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';

interface InactivityModalProps {
  open: boolean;
  onContinue: () => void;
  onExit: () => void;
  onClose: () => void;
  message?: string;
  primaryColor?: string;
  secondaryColor?: string;
  disableScrollLock?: boolean;
}

const COUNTDOWN_SECONDS = 10;

const InactivityModal: React.FC<InactivityModalProps> = ({ open, onContinue, onExit, onClose, message, primaryColor, secondaryColor, disableScrollLock }) => {
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);
  useEffect(() => {
    if (!open) return;
    setCountdown(COUNTDOWN_SECONDS);
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    if (countdown <= 0) {
      onExit();
      if (onClose) onClose();
    }
  }, [countdown, open, onExit, onClose]);

  const handleContinue = () => {
    onContinue();
    if (onClose) onClose();
  };
  const handleExit = () => {
    onExit();
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={handleContinue} maxWidth="xs" fullWidth disableScrollLock={disableScrollLock}>
      <DialogContent style={{ textAlign: 'center', padding: 32 }}>
        <Typography variant="h6" gutterBottom style={{ fontWeight: 500 }}>
          {message || 'Do you want to continue your order?'}
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', paddingBottom: 24 }}>
        <Button
          onClick={handleContinue}
          color="primary"
          variant="contained"
          style={{
            minWidth: 100,
            backgroundColor: primaryColor || undefined,
            color: secondaryColor || undefined,
          }}>
          Yes
        </Button>
        <Button
          onClick={handleExit}
          color="primary"
          variant="outlined"
          style={{
            minWidth: 140,
            color: primaryColor || undefined,
            borderColor: primaryColor || undefined,
            backgroundColor: 'transparent',
          }}>
          No{countdown > 0 ? ` (${countdown})` : ''}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactivityModal;
